export default "__VITE_ASSET__39fdb9a0__"